import script from "./resetUserPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./resetUserPassword.vue?vue&type=script&setup=true&lang=js"

import "./resetUserPassword.vue?vue&type=style&index=0&id=0724f787&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0724f787"]])

export default __exports__